import React from "react";
import { Box, BoxProps } from "@chakra-ui/react";

export const Blockquote = (props: BoxProps) => (
  <Box pl="4" py="1.5" borderLeftWidth="2px" borderColor="primary" {...props} />
);
